export default {
  isModalLaunched: (state) => state.isModalLaunched,
  modalComponent: (state) => state.modalComponent,
  modalProperties: (state) => state.modalProperties,
  modalCloseCallback: (state) => state.modalCloseCallback,
}
